import { useQuery } from "@tanstack/react-query";

import {
  getInvoices,
  getInvoicesPartner,
  type InvoiceType,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { INVOICE_QUERY_KEYS } from "./queryKeys";

export interface InvoiceListQueryParams {
  offset?: number;
  limit?: number;
  invoiceType?: InvoiceType | null;
  search?: string | null;
  isAdmin?: boolean;
}

export function useInvoiceListQuery(params: InvoiceListQueryParams) {
  const { offset, limit, invoiceType, search, isAdmin } = params;

  const apiFn = isAdmin ? getInvoices : getInvoicesPartner;

  return useQuery({
    queryKey: INVOICE_QUERY_KEYS.list(params),
    queryFn: processResponse(() => apiFn(offset, limit, invoiceType, search)),
  });
}
